import {Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { RxComponent } from 'app/shared/components/common/rx.component';

@Component({
  selector: 'itpx-multi-content-deliverable-list',
  templateUrl: './multi-content-deliverable-list.component.html',
  styleUrls: ['../../common/style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class MultiContentDeliverableListComponent extends RxComponent implements OnInit {
  @Input() deliverables$: Observable<any[]>;
  @Output() triggerParent = new EventEmitter<any>();
  private sortedDeliverables$: Observable<any[]>;

  constructor() {
    super();
   }

  ngOnInit() {
    this.sortedDeliverables$ = this.deliverables$.map(deliverables => deliverables.sort((a, b) => a.order - b.order));
  }

  trackByFn(index, item) {
    return index; // or item.id
  }

  onTriggerParent(event: any) {
    this.triggerParent.emit(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/multi-content-deliverable-list/multi-content-deliverable-list.component.ts